module.exports = {
    apiKey: "AIzaSyBl2QRfmEBDa6f8u4u8UhHWI1moxTX3vL8",
    authDomain: "neurosonology-journal.firebaseapp.com",

    projectId: "neurosonology-journal",
    storageBucket: "neurosonology-journal.appspot.com",
    messagingSenderId: "875247795336",
    appId: "1:875247795336:web:2d0b96d87658e4e0c4333d"
};